import { z } from 'zod'

/** Where a credit purchase (or saving a card) stands. */
export const BILLING_PURCHASE_STATUSES = ['pending', 'succeeded', 'failed', 'expired', 'cancelled'] as const

export const billingPurchaseStatusSchema = z.enum(BILLING_PURCHASE_STATUSES)

export type BillingPurchaseStatus = z.infer<typeof billingPurchaseStatusSchema>

export const PRISMA_BILLING_PURCHASE_STATUSES = ['PENDING', 'SUCCEEDED', 'FAILED', 'EXPIRED', 'CANCELLED'] as const

export type PrismaBillingPurchaseStatus = (typeof PRISMA_BILLING_PURCHASE_STATUSES)[number]

export const BILLING_PURCHASE_STATUS_FROM_PRISMA = {
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
} as const satisfies Record<PrismaBillingPurchaseStatus, BillingPurchaseStatus>

export const BILLING_PURCHASE_STATUS_TO_PRISMA = {
  pending: 'PENDING',
  succeeded: 'SUCCEEDED',
  failed: 'FAILED',
  expired: 'EXPIRED',
  cancelled: 'CANCELLED',
} as const satisfies Record<BillingPurchaseStatus, PrismaBillingPurchaseStatus>

/** A purchase that can no longer be paid. */
export const CLOSED_PURCHASE_STATUSES = ['failed', 'expired', 'cancelled'] as const satisfies readonly BillingPurchaseStatus[]

/** A purchase that has not succeeded, so tax and the total are not known. */
export const UNPAID_PURCHASE_STATUSES = ['pending', 'failed', 'expired', 'cancelled'] as const satisfies readonly BillingPurchaseStatus[]

/** A Checkout session that is no longer waiting: a paid or closed purchase, or a finished card setup. */
export const SETTLED_CHECKOUT_STATUSES = ['succeeded', 'failed', 'expired', 'cancelled'] as const satisfies readonly BillingPurchaseStatus[]
